var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flash-message", class: `is-${_vm.data.type}` },
    [
      _c("div", { staticClass: "flash-message-button is-badge" }, [
        _c(
          "div",
          { staticClass: "flash-message-icon" },
          [_c("BaseIcon", { attrs: { icon: _vm.data.type + "-message" } })],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "flash-message-content",
        domProps: { innerHTML: _vm._s(_vm.data.message) },
      }),
      _vm._v(" "),
      _c(
        "a",
        { staticClass: "flash-message-button", on: { click: _vm.close } },
        [
          _c(
            "div",
            { staticClass: "flash-message-icon" },
            [_c("BaseIcon", { attrs: { icon: "cross" } })],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }